import React, { useEffect, useRef, useState } from 'react';
import AutoGenTable from './Table';
import AutoFilter from './Filter';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { exportExcelAutoGenCoupon, getListAutoGenCouponService } from 'services/coupon.service';
import { defaultParams, showToast } from 'utils/helpers';
import Loading from 'components/shared/Loading';
import moment from 'moment';
import { notification } from 'antd';

function AutoCodeDetailPage() {
  const { coupon_id } = useParams();
  const [dataList, setDataList] = useState({});
  const [params, setParams] = useState({ ...defaultParams });
  const [loading, setLoading] = useState(false);
  const latestRequestRef = useRef(0);

  useEffect(() => {
    if (!coupon_id) return undefined;

    const requestId = latestRequestRef.current + 1;
    latestRequestRef.current = requestId;
    setLoading(true);

    getListAutoGenCouponService(coupon_id, params)
      .then((value) => {
        if (latestRequestRef.current === requestId) setDataList(value || {});
      })
      .catch((error) => {
        if (latestRequestRef.current === requestId) {
          showToast.error(error?.message || 'Không thể tải danh sách mã giảm giá');
        }
      })
      .finally(() => {
        if (latestRequestRef.current === requestId) setLoading(false);
      });

    return () => {
      if (latestRequestRef.current === requestId) latestRequestRef.current += 1;
    };
  }, [coupon_id, params]);

  const { items, itemsPerPage, page, totalItems, totalPages, meta } = dataList;
  const [loadingExport, setLoadingExport] = useState(false);

  const onChange = (p) => setParams((prev) => ({ ...prev, ...p }));
  const onChangePage = (nextPage) => {
    if (!loading && Number(nextPage) !== Number(params.page)) {
      setParams((prev) => ({ ...prev, page: Number(nextPage) }));
    }
  };

  
  const exportExcel = () => {
    setLoadingExport(true);
    exportExcelAutoGenCoupon(coupon_id,params)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response?.data]));
        const link = document.createElement('a');
        link.href = url;
        const configDate = moment().format('DDMMYYYY');
        link.setAttribute('download', `Danh_sach_ma_giam${configDate}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => notification.error({ message: error.message || 'Lỗi tải tập tin.' }))
      .finally(() => setLoadingExport(false));
  };


  return (
    <React.Fragment>
      <div className='bw_main_wrapp'>
        <AutoFilter onChange={onChange} />
        <AutoGenTable
          loading={loading}
          loadingExport={loadingExport}
          meta={meta}
          params={params}
          onChangePage={onChangePage}
          data={items}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          page={page}
          totalItems={totalItems}
          exportExcel={exportExcel}
        />
      </div>
      {loadingExport && <Loading />}
    </React.Fragment>
  );
}

export default AutoCodeDetailPage;
